import { useToast } from "hooks/useToasts";
import { useEffect } from "react";

import { removeFormsWithToast } from "../utils/removeFormsWithToast";
import { BusinessRulesArgs } from "./useBusinessRules";

const REQUIRED_FORMS_BY_VALUATION = {
  RC: [],
  ACV: [],
  IACV: [], //["WCICFL33"],
} as const;

const AUTOMATED_VALUATION_FORMS = Object.values(REQUIRED_FORMS_BY_VALUATION).flat();

export function getRequiredValuationForm(valuation?: string) {
  return REQUIRED_FORMS_BY_VALUATION[valuation as keyof typeof REQUIRED_FORMS_BY_VALUATION];
}

export function isAutomatedValuationForm(formName: string) {
  return AUTOMATED_VALUATION_FORMS.includes(formName as (typeof AUTOMATED_VALUATION_FORMS)[number]);
}

export function useValuationRules({
  locationValues,
  forms,
  formsData,
  enabled,
  appendForm,
  removeForm,
  htmlIdGenerator,
}: BusinessRulesArgs) {
  const { valuation } = locationValues;
  const { addToast } = useToast();

  // {START: Add or remove required valuation forms}
  useEffect(() => {
    if (!enabled) return;

    const requiredForms: readonly string[] = getRequiredValuationForm(valuation) ?? [];

    const formsToRemove = forms
      .map((form, index) => ({ form, index }))
      .filter(({ form }) => {
        return isAutomatedValuationForm(form.name) && !requiredForms.includes(form.name);
      });

    removeFormsWithToast({
      addToast,
      removeForm,
      formsData,
      formsToRemove,
      reason: "due to a change in valuation",
    });

    requiredForms.forEach((formName) => {
      if (forms.some((form) => form.name === formName)) return;

      appendForm({
        formID: htmlIdGenerator()(),
        name: formName,
        fields: undefined,
      });
    });
  }, [valuation, forms, appendForm, removeForm, htmlIdGenerator, formsData, enabled, addToast]);
  // {END: Add or remove required valuation forms}
}
